import EntityType from 'constants/entity';
import { Environment } from '../../../config';
import request from '../../../utils/request';
import nativeAxios from 'axios';
import axios from 'axios';
import * as Types from '../types';
import FileType from 'constants/fileType';
import { varToStringParams } from 'utils/path';

export interface IUploadFileRes {
  file: string;
  path: string;
  originalname: string;
  mimetype: string;
}

export interface IUploadFileOutput extends Types.ResponseOutput {
  data: IUploadFileRes;
}

export const uploadFileNew = async (
  file: File,
  entityType: EntityType,
  handleFun?: (data: any) => void
) => {
  const formData = new FormData();
  formData.append('file', file);
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const id = Math.floor(Math.random() * 100000);
  const data = await axios.post(
    `${
      Environment.API_BASE_URL
    }/api/file/upload-single?path=${entityType.toLowerCase()}`,
    formData,
    {
      headers: headers,
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.floor(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        handleFun?.({ percentCompleted, file, id });
      },
    }
  );
  return data.data;
};

export const uploadFile = async (
  file: File,
  entityType: EntityType
): Promise<IUploadFileOutput> => {
  const formData = new FormData();
  formData.append('file', file);

  const { data }: any = await request(
    'post',
    `${
      Environment.API_BASE_URL
    }/api/file/upload-single?path=${entityType.toLowerCase()}`,
    {
      body: formData,
    }
  );
  return data;
};

export const downloadFile = async (
  pictureGuid: string,
  originalFileName: string
) => {
  const { data } = await nativeAxios({
    method: 'get',
    url: `${Environment.API_BASE_URL}/api/file/${pictureGuid}/download`,
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([data]));
  console.log('url', url);
  console.log('originalFileName', originalFileName);

  var a = document.createElement('a');
  a.href = url;
  a.download = originalFileName;
  document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
  a.click();
  a.remove();
};

export const uploadMultipleFile = async (
  files: FileList | File[],
  entityType: EntityType
) => {
  const formData = new FormData();
  for (let file of Array.from(files)) {
    formData.append('files', file);
  }

  const { data }: any = await request(
    'post',
    `${
      Environment.API_BASE_URL
    }/api/file/upload-multiple?path=${entityType.toLowerCase()}`,
    {
      body: formData,
    }
  );
  return data;
};

export const getFileByType = async (fileType: FileType) => {
  let query = varToStringParams({
    variablesArray: [{ key: 'fileType', value: fileType.toString() }],
  });
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/picture/file/by-type${query}`
  );
  return data;
};
